<form class="card-form">
  <div class="card-input-container card-number-input">
    <div class="card-input-label gus-font-light space-letter-047 line-height-24 fs16">Card number</div>

    <div #cardNumber class="gus-card-input card-number gus-font-light space-letter-047 line-height-24 fs16"></div>
  </div>

  <div class="flex flex-row gap10">
    <div class="card-input-container">
      <div class="card-input-label gus-font-light space-letter-047 line-height-24 fs16">Expiry date</div>

      <div #cardExpiry class="gus-card-input"></div>
    </div>

    <div class="card-input-container gus-font-light space-letter-047 line-height-24 fs16">
      <div class="card-input-label">CVV</div>

      <div #cardCvc class="gus-card-input"></div>
    </div>
  </div>
</form>

<div class="card-form-initializing-overlay" [ngClass]="{ 'fade-out': !initializing() }">
  <p class="loading-text">Initializing...</p>
</div>
